module.exports = __webpack_public_path__ + "img/mail.67db374e.svg";